import { httpClient } from "@/shared/services/http";

export class SearchHttpService {
  static async getSearchResponse(request: string) {
    const { data: response } = await httpClient.get(`api/search?q=${request}`);
    return response;
  }
}
